import { hidePopup, togglePopup } from '../popups/popup';
import { customFetch } from '../forms/ajax';
import { convertFormDataToDictionary } from '../forms/forms';

document.addEventListener('DOMContentLoaded', () => {
    // Show / hide grow-network popup when clicking the Grow link(s)
    for (const growNetworkLink of document.getElementsByClassName('grow-network'))
    {
        growNetworkLink.addEventListener('click', onClickGrowNetworkLink);
    }

    // Add new rows to form when click add-practice-button
    document.getElementById('add-practice-button').addEventListener('click', onClickAddPracticeButton);

    // Submit form when click grow-network-submit
    document.getElementById('grow-network-submit').addEventListener('click', onClickGrowNetworkSubmit);
});

function onClickGrowNetworkLink(event: MouseEvent)
{
    event.preventDefault();

    const growNetworkPopup = document.getElementById('grow-network-popup') as HTMLElement;
    togglePopup(growNetworkPopup);
}

function onClickAddPracticeButton()
{
    const rows = document.getElementById('grow-network-form-rows')!;
    const rowCount = rows.querySelectorAll('.grow-network-form-row').length;
    const newIndex = rowCount;

    const newRow = `
        <div class="grow-network-form-row" data-index="${newIndex}">
            <div>
                <label for="physicians[${newIndex}][name]">Practice/Doctor's Name:</label>
                <input id="physicians[${newIndex}][name]" type="text" name="physicians[${newIndex}][name]" placeholder="Name">
            </div>

            <div>
                <label for="physicians[${newIndex}][email]">Practice Email Address:</label>
                <input id="physicians[${newIndex}][email]" type="email" name="physicians[${newIndex}][email]" placeholder="mail@example.com">
            </div>
        </div>
    `;

    rows.insertAdjacentHTML('beforeend', newRow);
}

function onClickGrowNetworkSubmit()
{
    const growNetworkForm = document.getElementById('grow-network-form') as HTMLFormElement;

    const emailInputs = growNetworkForm.querySelectorAll('input[type=email]') as NodeListOf<HTMLInputElement>;

    // Build validation queue
    let validationQueue = Promise.resolve();
    for (const emailInput of emailInputs)
    {
        validationQueue = validationQueue.then(() => buildValidationTask(emailInput)).then();
    }

    // After validations, submit new network connections
    const formData = new FormData(growNetworkForm);
    const formDataDictionary = convertFormDataToDictionary(formData);
    const body = JSON.stringify(formDataDictionary);
    const csrfToken = document.querySelector('meta[name="_csrf"]').getAttribute('content');
    const csrfHeader = document.querySelector('meta[name="_csrf_header"]').getAttribute('content');

    validationQueue
        .then(() => customFetch('/api/network/grow', {
            body,
            method: 'POST',
            headers: {
                [csrfHeader]: csrfToken,
                ['Content-Type']: 'application/json'
            }
        }))
        .then(response => response.json())
        .then(() => {
            const growNetworkPopup = document.getElementById('grow-network-popup') as HTMLElement;
            hidePopup(growNetworkPopup);
            resetGrowNetworkForm(growNetworkPopup);
        })
        .catch(() => {});

    function buildValidationTask(emailInput: HTMLInputElement)
    {
        const email = emailInput.value.trim();

        return new Promise<void>((resolve, reject) => {
            const url = `/api/auth/user/${email}/exists`;

            customFetch(url)
                .then(response => response.json())
                .then((emailExists: boolean) => {
                    if (emailExists)
                    {
                        emailInput.setCustomValidity('A user for this email already exists');
                        emailInput.reportValidity();
                        reject();
                    } else
                    {
                        resolve();
                    }
                });
        });
    }
}

function resetGrowNetworkForm(growNetworkPopup: HTMLElement)
{
    const allFormRows = growNetworkPopup.querySelectorAll('.grow-network-form-row') as NodeListOf<HTMLElement>;
    for (const formRow of allFormRows)
    {
        const rowIndex = JSON.parse(formRow.getAttribute('data-index')) as number;
        if (rowIndex === 0)
        {
            // Clear out all inputs for first row
            for (const input of formRow.querySelectorAll('input') as NodeListOf<HTMLInputElement>)
            {
                input.value = '';
            }
        } else
        {
            // Remove all extra rows
            formRow.remove();
        }
    }
}
